import React from 'react'
import { Btn, CustomDataTableHeader } from '../../../../components'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { formatDateToLocale } from '../../../../services/util/date.service'
import TabBipsExcluidosModal from './TabBipsExcluidosModal'
import './TabHistorico.css'

const formatDateTime = value => {
  if (!value || value === '-') return '-'

  try {
    return formatDateToLocale(value, 'dd/MM/yy HH:mm:ss').toFormat('dd/MM/yy HH:mm:ss')
  } catch (e) {
    return '-'
  }
}

const TabBipsExcluidos = ({ bips, pickingId }) => {
  const [globalFilter, setGlobalFilter] = React.useState('')
  const [selectedBip, setSelectedBip] = React.useState(null)

  return (
    <>
      <div className="p-grid p-col-12">
        <div className="p-col-12">
          <Btn
            onClick={() => {
              const data = [
                ['Horário Exclusão', 'Produto', 'Vol', 'Uni', 'Excluído Por', 'Código Ativação'],
              ]
              bips.forEach(b => {
                data.push([
                  b.horario_exclusao,
                  b.produto,
                  b.vol,
                  b.uni,
                  b.excluido_por,
                  b.codigo_ativacao,
                ])
              })
              gerarArquivoExcel('BIPs Excluídos', data, 'bips_excluidos.xlsx')
            }}
          >
            Exportar
          </Btn>
        </div>
        <div className="p-col-12 p-datatable-responsive">
          <DataTable
            value={bips}
            emptyMessage={'Não existem BIPs excluídos'}
            header={
              <div style={{ width: '100%', height: 50 }}>
                <CustomDataTableHeader onChange={setGlobalFilter} />
              </div>
            }
            globalFilter={globalFilter}
            rows={15}
            paginator={true}
            selectionMode={'single'}
            onSelectionChange={e => setSelectedBip(e.value)}
            responsive={true}
          >
            <Column
              field={'horario_exclusao'}
              header={'Horário Exclusão'}
              className="column-responsive"
              style={{ width: '150px' }}
              body={bip => formatDateTime(bip.horario_exclusao)}
            />
            <Column
              field={'produto'}
              header={'Produto'}
              className="column-responsive column-important"
            />
            <Column
              field={'vol'}
              header={'Vol'}
              className="column-number"
              style={{ width: '80px' }}
            />
            <Column
              field={'uni'}
              header={'Uni'}
              className="column-number"
              style={{ width: '80px' }}
            />
            <Column
              field={'excluido_por'}
              header={'Excluído Por'}
              className="column-responsive"
              style={{ width: '180px' }}
            />
            <Column
              field={'codigo_ativacao'}
              header={'Código Ativação'}
              className="column-responsive"
              style={{ width: '150px' }}
            />
          </DataTable>
        </div>
      </div>
      <TabBipsExcluidosModal
        onClose={() => setSelectedBip(null)}
        visible={selectedBip !== null}
        bip={selectedBip}
        pickingId={pickingId}
      />
    </>
  )
}

export default TabBipsExcluidos
